module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0QzNDg0OCIgc3Ryb2tlLXdpZHRoPSI0LjIiPgogICAgPHBhdGggZD0iTTkgMTcuNGg0Mk0yMS42IDIzLjd2MjUuMk0zOC40IDIzLjd2MjUuMk0zMCAyMy43djI1LjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogICAgPHJlY3QgeD0iMTMuMiIgeT0iMTEuMSIgd2lkdGg9IjMzLjYiIGhlaWdodD0iNDQuMSIgcng9IjIuMSIvPgogICAgPHJlY3QgeD0iMjMuNyIgeT0iNC44IiB3aWR0aD0iMTIuNiIgaGVpZ2h0PSI2LjMiIHJ4PSIyLjEiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-trash.svg
// module id = 550
// module chunks = 0